/**
 * @file 上传图片api
 * @param
 * @author FranckChen(chenfan02@baidu.com)
 */

import {post} from '@/utils/decorate/request';
import {Url} from '@/utils/api';

export default function uploadImg(img) {
    const formData = new FormData();
    formData.append('contentImage', img);
    // 图片上传
    return post(Url.uploadImgUrl, formData, {
        'Content-type': 'multipart/form-data'
    }
    );
}
